import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { actions } from "../../../../store/modules";
import i18n from "../../../../plugins/i18n/i18n";
import moment from "moment";
import { Col, Row, Spin, notification as Notification, PageHeader, Button, Tooltip, Avatar } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { errorMessageNotification, isMobile } from "../../../../helpers";

import TripApprovalDetailOk from './TripApprovalDetailOk';
import TripApprovalDetailReason from './TripApprovalDetailReason';
import Direction from '../../components/GoogleMaps/Direction';


class TripApprovalDetail extends Component {

    constructor(props) {
        super(props);
        this.endpoint = { keyOne: "trip", idOne: this.props.match.params.id };
        this.state = {
            data: null,
            loadings: {
                data: false
            },
            isModalOk: false,
            isModalReason: false,
            values: {
                confirms: [],
                reasons: []
            },
            isConfirmSuccess: false,
            isReasonSuccess: false,

        };
        this.initMap = this.initMap.bind(this);

    }

    componentWillMount() {
        if (isMobile()) {
            this.setState({
                isResponsive: true,
            });
        }


        this.confirmValuePairs();
        this.reasosValuePairs();
        this.getData();


    }


    confirmValuePairs = type => {
        let endpoint = { keyOne: `trip/vendortripcostapprovalconfirms` };
        this.props
            .dispatch(
                actions.definitions.getDatas({
                    key: `${type}ValuePairs`,
                    ...endpoint
                })
            )
            .then(response => {
                let { values } = this.state;
                values.confirms = response

                this.setState({
                    values
                });
            });
    };


    reasosValuePairs = type => {
        let endpoint = { keyOne: `trip/vendortripcostobjectionreasons` };
        this.props
            .dispatch(
                actions.definitions.getDatas({
                    key: `${type}ValuePairs`,
                    ...endpoint
                })
            )
            .then(response => {
                let { values } = this.state;
                values.reasons = response

                this.setState({
                    values
                });
            });
    };

    getData = () => {

        let { loadings } = this.state;
        loadings.data = true;

        this.setState({ loadings });

        this.props.dispatch(actions.definitions.getData({
            ...this.endpoint,
            filter: this.filter
        }))
            .then(response => {

                loadings.data = false;
                this.setState({ loadings, data: response });

                try {
                    this.map.destroy();
                    this.map = null;
                } catch (e) {
                }

                this.ymap = window.ymaps;

                setTimeout(() => {
                    this.ymap.ready(this.initMap);
                }, 500);

            })
            .catch(error => {

                loadings.data = false;

                this.setState({
                    loadings
                });

                Notification.error({
                    message: i18n.t(`error`, {
                        lng: this.props.currentLanguage,
                    }),
                    description: errorMessageNotification(error),
                    className: "general-notification",
                    placement: "bottomLeft",
                    duration: 100,
                });

            })
    }

    initMap() {

        let { data } = this.state;


        var stops = data.routes
            .map(function (i) {
                return [i.latitude, i.longitude];
            })


        var coordinates = [41.045930450756735, 29.033413529100827];

        this.map = new this.ymap.Map('map-yandex', {
            center: coordinates,
            zoom: 13,
            controls: ['fullscreenControl']
        }, {
            buttonMaxWidth: 300,
            top: 100,
            left: 10
        });

        var zoomControl = new this.ymap.control.ZoomControl({
            options: {
                size: "small"
            }

        });

        this.map.controls.add(zoomControl);

        var fullscreenControl = new this.ymap.control.FullscreenControl({
            options: {
                right: 50,
                bottom: 50,
                width: 26,
                height: 25
            }

        });

        this.map.controls.add(fullscreenControl);

        var startPoint = new window.ymaps.GeoObject({
            geometry: {
                type: "Point",
                coordinates: stops[0]
            },
            properties: {
                iconContent: 'Başlangıç',
            }
        }, {
            preset: "islands#darkGreenStretchyIcon",
        });

        this.map.geoObjects.add(startPoint);

        var endPoint = new window.ymaps.GeoObject({
            geometry: {
                type: "Point",
                coordinates: stops[stops.length - 1]
            },
            properties: {
                iconContent: 'Bitiş',
            }
        }, {
            preset: "islands#redStretchyIcon"
        });

        this.map.geoObjects.add(endPoint);

        data.routes.forEach((route, index) => {

            var hintContent = "<br> ";
            hintContent += route.shortAddress;
            hintContent += "<br> ";
            hintContent += "<br> ";
            hintContent += "<br> ";
            hintContent += "<br> ";
            hintContent += "<br> ";

            var myCircle = new window.ymaps.Circle([
                [route.latitude, route.longitude],
                100
            ], {
                hintContent: hintContent
            }, {
                fillColor: "#32CD3266",
                strokeColor: "#2CAD03",
                strokeOpacity: 0.9,
                strokeWidth: 0.5
            });

            this.map.geoObjects.add(myCircle);
        })

        var viaPointActualPolylineItems = [];

        let actualRoutes = data.actualRoutes.find(x => x.source === "Vendor" && x.type === "Going");

        if (actualRoutes && actualRoutes.coordinates.length > 0) {

            viaPointActualPolylineItems = actualRoutes.coordinates
                .map(function (i) {
                    return [i.latitude, i.longitude];
                });


            var viaPointActualPolyline = new window.ymaps.Polyline(viaPointActualPolylineItems, {
                balloonContent: "Gerçekleşen Güzergah"
            }, {
                fillColor: "#32a852",
                strokeColor: "#32a852",
                strokeOpacity: 1,
                strokeWidth: 10,


            });

            this.map.geoObjects.add(viaPointActualPolyline);
            this.map.setBounds(viaPointActualPolyline.geometry.getBounds());

        }


        var viaPointPolylineItems = [];

        let plannedRoutes = data.actualRoutes.find(x => x.source === "GoogleMaps" && x.type === "Going").coordinates;

        viaPointPolylineItems = plannedRoutes
            .map(function (i) {
                return [i.latitude, i.longitude];
            });


        var viaPointPolyline = new window.ymaps.Polyline(viaPointPolylineItems, {
            balloonContent: "Planlanan Güzergah"
        }, {
            // fillColor: "#bb2167",
            // strokeColor: "#bb2167",
            // strokeOpacity: 1,
            // strokeWidth: 8

            // balloonCloseButton: false,
            strokeColor: "#bb2167",
            strokeWidth: 5,
            strokeOpacity: 1,
            strokeStyle: '1 2'


        });

        this.map.geoObjects.add(viaPointPolyline);
        this.map.setBounds(viaPointPolyline.geometry.getBounds());


    }

    onRoute = (directionType) => {
        let { data } = this.state

        return data.routes.find(x => x.type === directionType).address
    }

    toggleOkModal = () => {
        this.setState({ isModalOk: !this.state.isModalOk }, () => {
            if (!this.state.isModalOk && this.state.isConfirmSuccess) {
                this.props.history.push(
                    `/app/tripapprovals`
                )
            }
        })
    }

    onOkSuccessOkModal = () => {
        this.setState({ isConfirmSuccess: true })
    }

    toggleReasonModal = () => {
        this.setState({ isModalReason: !this.state.isModalReason }, () => {
            if (!this.state.isModalReason && this.state.isReasonSuccess) {
                this.props.history.push(
                    `/app/tripapprovals`
                )
            }
        })

    }

    onOkSuccessReasonModal = () => {
        this.setState({ isReasonSuccess: true })
    }


    render() {

        let { loadings, data, isModalReason, isModalOk, values } = this.state;


        return (

            <Fragment>

                {
                    loadings.data &&
                    <div className="ant-loading loading-content">
                        <Spin
                            tip={`${i18n.t(`loading`, {
                                lng: this.props.currentLanguage,
                            })}`}
                        />
                    </div>
                }

                {
                    !loadings.data &&
                    <div className='trip-approval-detail'>
                        <div className='page-header'>
                            <Row>
                                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                    <PageHeader
                                        className="site-page-header"
                                        onBack={() => this.props.history.push(
                                            `/app/tripapprovals`
                                        )}
                                        title="Geri Dön"
                                    />
                                </Col>

                            </Row>
                        </div>
                        <div className='trip-aproval-detail-container'>
                            <div className=''>
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        {
                                            this.props.account.mapsClient === "Yandex" ?
                                                <div id="map-yandex" className="map" style={{ width: 1250, height: 350 }} />
                                                :
                                                <Direction data={data} />
                                        }
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div className="maps-warning">
                                            Tahmini maliyet ve gerçekleşen maliyet arasında fark oluşmasından dolayı yolculuk detaylarını kontrol ediniz.
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                        <div className="header">
                                            YOLCULUK DETAYI

                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div className="date-container">
                                            <div className='date'>
                                                {moment(data.departureDate).format('DD MMMM YYYY HH:mm')}
                                            </div>
                                            <div className='day'>
                                                {moment(data.departureDate).format('dddd')}
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div className="routes">
                                            <div className='point'>
                                                <img className='icon' src={"/assets/img/icons/pin-circle-icon.png"} alt=''></img>
                                                {this.onRoute("StartPoint")}
                                            </div>

                                            <div className='point'>
                                                <img className='icon' src={"/assets/img/icons/pin-circle-icon.png"} alt=''></img>
                                                {this.onRoute("EndPoint")}
                                            </div>

                                        </div>
                                    </Col>
                                </Row>

                                <Row className='items'>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <div className="item-title">YOLCULUK DETAYI</div>
                                        <ul>
                                            <li>
                                                <div className='label'>YOLCULUK ID</div>
                                                <div className='text'>{data.id}</div>
                                            </li>
                                            <li>
                                                <div className='label'>TRANSFER TİPİ</div>
                                                <div className='text'>{data.transferType.name}</div>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <div class="item-title">SÜRÜCÜ BİLGİLERİ</div>
                                        <ul>
                                            <li>
                                                <div className='label'>SÜRÜCÜ</div>
                                                <div className='text'>{data.driver.nameLastname}</div>
                                            </li>
                                            <li>
                                                <div className='label'>ARAÇ</div>
                                                <div className='text'>{data.vehicle.name}</div>
                                            </li>
                                            <li>
                                                <div className='label'>PLAKA</div>
                                                <div className='text'>{data.vehicle.plate}</div>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <div class="item-title">KM VE SÜRE BİLGİSİ</div>
                                        <ul>
                                            <li>
                                                <div className='label'>TOPLAM KM</div>
                                                <div className='text'>{parseFloat(data.cost.distance / 1000).toFixed(2)}</div>
                                            </li>
                                            <li>
                                                <div className='label'>BEKLEME SÜRESİ</div>
                                                <div className='text'>{data.cost.waitingDuration.substring(0, 8)}</div>
                                            </li>
                                            <li>
                                                <div className='label'>TOPLAM SÜRE</div>
                                                <div className='text'>{data.cost.duration.substring(0, 8)}</div>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <div class="item-title">DİĞER</div>
                                        <ul>
                                            <li>
                                                <div className='label'>TEDARİKÇİ NOTU</div>
                                                <div className='text'>{data.noteOfVendor ? data.noteOfVendor : "-"}</div>
                                            </li>
                                            <li>
                                                <div className='label'>BİRLEŞTİRİLMİŞ TALEP Mİ?</div>
                                                <div className='text'>{data.isRelatedTrip ? "Evet" : "Hayır"}</div>
                                            </li>
                                        </ul>
                                    </Col>
                                </Row>

                                <Row className='items'>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div class="item-title">TAHMİNİ MALİYET</div>
                                        <ul className='prices'>
                                            <li>
                                                <span className='text'>{data.estimatedCost.message}</span>
                                                <span className='value'> {data.estimatedCost.estimatedCost.toFixed(2)}₺</span>
                                            </li>
                                        </ul>
                                        <div class="item-title">YOLCULUK ÜCRETLERİ</div>
                                        <ul className='prices'>
                                            {
                                                data.cost.additionalCostDetails.map((item) => {
                                                    return (
                                                        <li key={item.costType}>
                                                            <Tooltip title="">
                                                                <InfoCircleOutlined />
                                                            </Tooltip>
                                                            <span className='text'>{item.costType}</span>
                                                            <span className='value'> {item.cost.toFixed(2)}₺</span>
                                                        </li>
                                                    )
                                                })
                                            }
                                            {
                                                data.cost.revisionCost && data.cost.revisionCost > 0 &&
                                                <li>
                                                    <span className='text'>Revize Tutar</span>
                                                    <span className='value'> {data.cost.revisionCost.toFixed(2)}₺</span>
                                                </li>
                                            }

                                            <li>
                                                <span className='text total'>Toplam</span>
                                                <span className='value total'> {data.cost.totalCost.toFixed(2)}₺</span>
                                            </li>
                                        </ul>
                                    </Col>
                                    <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <div class="item-title">İŞLEMLER</div>
                                        <ul className='approvals'>
                                            {
                                                data.costStatusHistories.map((item) => {
                                                    return (
                                                        <li key={item.text}>
                                                            <img src={item.picturePath} class="" alt='' />
                                                            <div className='name'>{item.nameLastname}</div>
                                                            <div className='description'> {item.text}</div>
                                                        </li>
                                                    )
                                                })
                                            }


                                        </ul>
                                    </Col>
                                </Row>

                                {
                                    !data.cost.isOwnerApproval &&

                                    <div className='approver-view'>

                                        <Row className='approver-view-container'>
                                            <Col xs={4} sm={4} md={4} lg={4} xl={4}>
                                                <div class="owner-info">
                                                    <div className='subject'>Bu seyahat maliyet onayınınızı bekliyor.</div>
                                                </div>
                                            </Col>
                                            <Col xs={8} sm={8} md={8} lg={8} xl={8}>

                                                {
                                                    data.owner &&
                                                    <Fragment>
                                                        {
                                                            data.owner.picturePath ?
                                                                <Avatar
                                                                    src={data.owner.picturePath}
                                                                    size={50}
                                                                /> :
                                                                <Avatar
                                                                    src={"/assets/img/icons/empty-avatar.png"}
                                                                    size={50}
                                                                />
                                                        }
                                                        <div class="owner-info">
                                                            <div className='subject'>TALEP SAHİBİ</div>
                                                            <div className='description'>{data.owner.nameLastname}</div>
                                                        </div>

                                                    </Fragment>
                                                }

                                            </Col>
                                            <Col xs={6} sm={6} md={6} lg={6} xl={6} style={{ paddingRight: 10 }}>
                                                <Button
                                                    htmlType="submit"
                                                    type="default"
                                                    className="ant-btn-red width-100"
                                                    style={{ height: 40 }}
                                                    onClick={() => this.toggleReasonModal()}

                                                >
                                                    REDDET
                                                </Button>
                                            </Col>
                                            <Col xs={6} sm={6} md={6} lg={6} xl={6} style={{ paddingRight: 10 }}>

                                                <Button
                                                    htmlType="submit"
                                                    type="primary"
                                                    className="ant-btn width-100"
                                                    style={{ height: 40 }}
                                                    onClick={() => this.toggleOkModal()}
                                                >
                                                    ONAYLA
                                                </Button>

                                            </Col>
                                        </Row>

                                        {/* <Row className='approver-view-container'>
                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
                                                <Button
                                                    htmlType="submit"
                                                    type="primary"
                                                    className="ant-btn-red width-100"
                                                    style={{ height: 40 }}
                                                    onClick={() => this.toggleReasonModal()}

                                                >
                                                    İTİRAZ ET
                                                </Button>
                                            </Col>

                                            <Col xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <Button
                                                    htmlType="submit"
                                                    type="primary"
                                                    className="ant-btn width-100"
                                                    style={{ height: 40 }}
                                                    onClick={() => this.toggleOkModal()}
                                                >
                                                    ONAYLA
                                                </Button>
                                            </Col>
                                        </Row> */}

                                    </div>
                                }

                            </div>

                        </div>
                    </div>
                }

                {
                    !loadings.data && data &&
                    <TripApprovalDetailOk
                        handleToggle={this.toggleOkModal}
                        isModalOpen={isModalOk}
                        warningMessage={data.cost.kmDeviationWarningMessage}
                        cost={data.cost}
                        confirms={values.confirms}
                        id={data.id}
                        onSuccess={this.onOkSuccessOkModal}
                    />
                }

                {
                    !loadings.data && data &&
                    <TripApprovalDetailReason
                        handleToggle={this.toggleReasonModal}
                        isModalOpen={isModalReason}
                        reasons={values.reasons}
                        warningMessage={data.cost.kmDeviationWarningMessage}
                        cost={data.cost}
                        id={data.id}
                        onSuccess={this.onOkSuccessReasonModal}
                    />
                }



            </Fragment>

        );
    }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(TripApprovalDetail);


// WEBPACK FOOTER //
// ./src/components/App/Views/TripApproval/TripApprovalDetail.js